import { UploadFile } from 'antd/lib/upload/interface';

export interface Attachement extends UploadFile {
    descripcion: string;
    contentTypeHeader: string;
    notificacionId: number;
    nombre: string;
}
export enum Importancia {
    Alto = 'Alto',
    Medio = 'Medio',
    Bajo = 'Bajo'
}
export interface AudienciaOo {
    notificacionId: number;
    ooId: number;
}
export interface AudienciaMunicipio {
    notificacionId: number;
    municipioId: number;
}
export interface Notification {
    id: number;
    titulo: string;
    descripcion: string;
    fechaInicio: string;
    fechaFin: string;
    importancia: Importancia;
    leida: boolean;
    archivosAdjuntos: Attachement[];
    audienciaTodosOo: boolean;
    listaAudienciaOo: AudienciaOo[];
    audienciaTodosMunicipios: boolean;
    listaAudienciaMunicipios: AudienciaMunicipio[];
}
